import { ChangeEvent, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { EmployNumListType } from 'types/kodawari';

/**
 * 従業員数に関するカスタムフック
 * @param initialEmployNumList
 * @returns 従業員数の値と更新する関数を含むオブジェクト
 */
export const useEmployeeNum = (initialEmployNumList: EmployNumListType[]) => {
  const [employNumList, setEmployNumList] =
    useState<EmployNumListType[]>(initialEmployNumList);

  const selectedEmployNumList = employNumList
    .filter(({ isChecked }) => isChecked)
    .map(({ value }) => value);

  // チェック状態更新処理
  const updateIsCheckedEmployNumList = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const checkedList = employNumList.map((item) => {
      if (item.value !== event.target.value) return item;

      return {
        ...item,
        isChecked: event.target.checked,
      };
    });

    setEmployNumList(checkedList);

    return checkedList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  };

  // 求人件数更新処理
  const updateEmployNumListJobCount = (
    employNumListJobCountList: JobCountDetailResponse[] | undefined
  ) => {
    setEmployNumList((pre) =>
      pre.map((item) => ({
        ...item,
        jobCount: findJobCount(employNumListJobCountList, item.value),
      }))
    );
  };

  // チェック状態クリア処理
  const clearIsCheckedEmployNumList = () => {
    const checkedList = employNumList.map((item) => {
      return {
        ...item,
        isChecked: false,
      };
    });
    setEmployNumList(checkedList);
  };

  return {
    employNumList,
    selectedEmployNumList,
    updateIsCheckedEmployNumList,
    updateEmployNumListJobCount,
    clearIsCheckedEmployNumList,
  };
};
